import React, { FC, useCallback, useMemo, useState } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import { v4 as uuid } from 'uuid'

import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'

import { getProps } from './utils'

import {
  FormFieldProps,
} from '../../../../types/frontend/form'

import {
  injectDefaultValues,
} from '../../../../utils/form'

import Table from '../../table/SimpleTable'
import Window from '../../dialog/Window'

import HelperText from './HelperText'
import FormDialog from '../Dialog'

import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'

const useStyles = makeStyles(theme => ({
  root: {
    //padding: theme.spacing(4),
  },
  title: {

  },
  content: {
    margin: theme.spacing(2),
  },
  titleText: {
    fontWeight: 'bold',
  },
  addButton: {
    marginTop: theme.spacing(2),
  },
  actionButton: {
    margin: theme.spacing(1),
  },
  description: {
    color: '#999'
  },
  helperText: {
    marginTop: theme.spacing(2),
  }
}))

const DEFAULT_FIELDS = [{
  title: 'Name',
  name: 'name',
}]

const List: FC<React.PropsWithChildren<FormFieldProps>> = (props) => {

  const classes = useStyles()
  const {
    field: {
      name,
      value,
    },
    form: {
      setFieldValue,
    },
    disabled,
    error,
    touched,
    item,
    readonly,
  } = getProps(props)

  const [ deletingItem, setDeletingItem ] = useState<any>(null)
  const [ editingItem, setEditingItem ] = useState<any>(null)

  const getItemName = (data: any) => {
    if(!item.list) return ''
    return data[item.list.name_field] || data.name
  }

  const tableData = value

  const onCancelForm = useCallback(() => setEditingItem(null), [])
  const onCancelDelete = useCallback(() => setDeletingItem(null), [])
  const onSubmitForm = useCallback((values: any) => {
    if(!values.id) {
      values.id = uuid()
      values.createdAt = new Date().toLocaleString()
      setFieldValue(name, value.concat([values]))
    }
    else {
      setFieldValue(name, value.map((data: any) => {
        return data.id == values.id ?
          values :
          data
      }))
    }
    setEditingItem(null)
  }, [
    value,
  ])

  const onConfirmDelete = useCallback(() => {
    if(!deletingItem) return
    setFieldValue(name, value.filter((data: any) => data.id != deletingItem.id))
    setDeletingItem(null)
  }, [
    value,
    deletingItem,
  ])

  const tableFields = item.list?.table || []
  const schema = item.list?.schema || []
  const validation = item.list?.validation

  const getActions = useCallback((item: any) => {
    if(readonly) return null
    return (
      <>
        <Tooltip title="Delete">
          <IconButton
            size="small"
            disabled={ disabled }
            onClick={ () => setDeletingItem(item) }
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Edit">
          <IconButton
            size="small"
            disabled={ disabled }
            onClick={ () => setEditingItem(item) }
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </>
    )
  }, [
    readonly,
    disabled,
  ])

  return (
    <div className={ classes.root }>
      <div className={ classes.title }>
        <Typography gutterBottom variant="subtitle1" className={ classes.titleText }>
          { item.title || item.id }
        </Typography>
      </div>
      <div className={ classes.addButton }>
        {
          !readonly && (
            <Button
              variant="contained"
              size="small"
              disabled={ disabled }
              onClick={ () => setEditingItem(injectDefaultValues(schema, {})) }
            >
              Add { item.list?.item_title }&nbsp;<AddIcon />
            </Button>
          )
        }
      </div>
      <div className={ classes.helperText }>
        <HelperText
          helperText={ touched && error ? error : item.helperText }
          error={ error ? true : false }
          touched={ touched }
        />
      </div>
      <div className={ classes.content }>
        <Table
          data={ tableData }
          fields={ tableFields }
          getActions={ getActions }
        />
      </div>
      {
        deletingItem && (
          <Window
            open
            withCancel
            title="Confirm delete"
            submitTitle="Delete"
            onCancel={ onCancelDelete }
            onSubmit={ onConfirmDelete }
          >
            <Typography>
              Are you absolutely sure you want to delete { getItemName(deletingItem) }?
            </Typography>
          </Window>
        )
      }
      {
        editingItem && (
          <FormDialog
            withCancel
            schema={ schema }
            initialValues={ editingItem }
            validationSchema={ validation }
            submitTitle="Confirm"
            onSubmit={ onSubmitForm }
            onCancel={ onCancelForm }
          />
        )
      }
    </div>
  )
}

export default List